
















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
//@ts-ignore
import store from "../../store";

@Component({
    components: {},
    props: {},
})

export default class PageSmallWindowResolution extends Vue {
    private readonly image_bg = '/images/small-window-size-bg.png';
    private readonly image_bg_laptop= '/images/small-window-size-bg-laptop.png';
    private readonly image_bg_mobile= '/images/small-window-size-bg-mobile.png';
}
